export interface ServiceItem {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  imageLabel: string;
  imageSrc: string;
  highlights: string[];
  process?: { step: string; title: string; description: string }[];
}

export const services: ServiceItem[] = [
  {
    slug: "construction",
    title: "Construction",
    subtitle: "Génie Civil & Bâtiment",
    description:
      "De la conception à la réalisation, notre bureau d'études accompagne vos projets avec rigueur et professionnalisme. Nous intervenons sur des bâtiments résidentiels et commerciaux du R+1 au R+4+, des ponts et ouvrages d'art, des antennes cellulaires, des piscines, ainsi que des travaux de rénovation complète.",
    imageLabel: "Chantier de construction",
    imageSrc: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80&auto=format&fit=crop",
    highlights: [
      "Bâtiments résidentiels & commerciaux (R+1 à R+4+)",
      "Ponts & ouvrages d'art",
      "Antennes cellulaires & structures métalliques",
      "Piscines & aménagements extérieurs",
      "Rénovation & réhabilitation",
      "Bureau d'études intégré",
    ],
    process: [
      { step: "01", title: "Étude", description: "Analyse du terrain, étude de faisabilité et relevés techniques" },
      { step: "02", title: "Conception", description: "Plans architecturaux, calculs de structure et devis détaillé" },
      { step: "03", title: "Planification", description: "Calendrier d'exécution, mobilisation des équipes et matériaux" },
      { step: "04", title: "Exécution", description: "Réalisation des travaux avec suivi qualité permanent" },
      { step: "05", title: "Livraison", description: "Contrôle final, réception et remise des clés au client" },
    ],
  },
  {
    slug: "travaux-publics",
    title: "Travaux Publics",
    subtitle: "Infrastructure & Aménagement",
    description:
      "Construction, entretien et réparation des routes, réseaux d'eau, systèmes d'assainissement et espaces publics au service du développement national. Nous contribuons à l'essor des infrastructures du Haut-Katanga et au-delà.",
    imageLabel: "Travaux routiers",
    imageSrc: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80&auto=format&fit=crop",
    highlights: [
      "Construction & entretien de routes et voiries",
      "Ponts & ouvrages de franchissement",
      "Réseaux d'eau potable & assainissement",
      "Forages & puits",
      "Aménagement d'espaces publics",
      "Terrassement & nivellement",
    ],
  },
  {
    slug: "logistique",
    title: "Transport & Logistique",
    subtitle: "Engins & Acheminement",
    description:
      "Nous disposons d'une flotte d'engins de terrassement avec une gestion complète de la maintenance et de la logistique d'approvisionnement. Nous assurons le transport de matériaux et l'approvisionnement international pour vos chantiers.",
    imageLabel: "Engins de terrassement",
    imageSrc: "https://images.unsplash.com/photo-1580901368919-7738efb0f228?w=800&q=80&auto=format&fit=crop",
    highlights: [
      "Location d'engins de terrassement",
      "Transport de matériaux de construction",
      "Approvisionnement international",
      "Gestion de flotte & maintenance",
      "Logistique de chantier",
      "Acheminement ferroviaire & routier",
    ],
  },
  {
    slug: "sst",
    title: "Santé & Sécurité",
    subtitle: "SST",
    description:
      "La sécurité est au cœur de chaque chantier. Nous dotons tous nos travailleurs d'équipements de protection adaptés et respectons les normes SST internationales. Nous proposons des audits de sécurité, des formations et des plans de prévention.",
    imageLabel: "Équipements de sécurité",
    imageSrc: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80&auto=format&fit=crop",
    highlights: [
      "Audit sécurité de chantier",
      "Équipements de protection individuelle (EPI)",
      "Formations sécurité pour le personnel",
      "Plans de prévention des risques",
      "Conformité aux normes internationales",
      "Signalisation & balisage de chantier",
    ],
  },
  {
    slug: "digital",
    title: "Solutions Digitales & IA",
    subtitle: "Transformation Numérique & Intelligence Artificielle",
    description:
      "RAVA intègre un pôle technologique dédié au développement logiciel, à l'analyse de données et à l'intelligence artificielle. En partenariat avec des professionnels issus de l'Université McGill et d'Omics Data Solutions Inc., nous accompagnons les entreprises dans leur transformation numérique avec une expertise de niveau international en data science, machine learning et ingénierie logicielle.",
    imageLabel: "Développement logiciel et analyse de données",
    imageSrc: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80&auto=format&fit=crop",
    highlights: [
      "Développement d'applications web, mobile et desktop sur mesure",
      "Création de plateformes métier et systèmes de gestion intégrés",
      "Business Intelligence : tableaux de bord, reporting et visualisation de données",
      "Modélisation prédictive et machine learning (classification, régression, clustering)",
      "Traitement du langage naturel (NLP) et vision par ordinateur",
      "Pipelines de données, ETL et architecture data lake / data warehouse",
      "Intégration d'APIs, migration cloud (AWS, Azure, GCP)",
      "Audit technologique et stratégie de transformation digitale",
    ],
    process: [
      { step: "01", title: "Audit & Cadrage", description: "Analyse des besoins métier, cartographie des systèmes existants, identification des opportunités d'optimisation par la donnée et l'automatisation" },
      { step: "02", title: "Architecture & Conception", description: "Définition de l'architecture technique, choix des technologies, modélisation des données et prototypage des interfaces" },
      { step: "03", title: "Développement & Entraînement", description: "Implémentation agile du logiciel, entraînement et validation des modèles ML, tests unitaires et d'intégration" },
      { step: "04", title: "Déploiement & Formation", description: "Mise en production, migration des données, formation des équipes utilisatrices et documentation complète" },
      { step: "05", title: "Support & Évolution", description: "Monitoring des performances, maintenance évolutive, réentraînement des modèles et amélioration continue" },
    ],
  },
];
